import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { Observable } from 'rxjs/Observable';

import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';

/**
 * Service for create organisation related calls.
 */
@Injectable()
export class CreateOrganisationService {
    constructor(
        private requestService: ObservableRequestService,
        private domSanitizer: DomSanitizer) { }

    addOrg(body: Object): Observable<any> {
        return this.requestService
            .postRequest(ConstantsService.ADD_ORGANISATION_URL,
            this.requestService.serialize(body),
            this.requestService.getFormEncodedContentType());
    };
}



// WEBPACK FOOTER //
// ./src/app/shared/components/createorganisation/create-organisation.service.ts